import React from 'react';
import { useLocation } from 'react-router-dom';
import { Icon } from './index.jsx';

/**
 * MobileBottomNav Component
 * 
 * A reusable fixed bottom navigation bar for mobile devices.
 * Redesigned with a cleaner "sheet" look and rounded top corners.
 * 
 * @param {Array} items - Array of navigation items: { id, label, icon, onClick, active, path }
 * @param {string} className - Optional custom classes
 */
export const MobileBottomNav = ({ items, className = '' }) => {
    const location = useLocation();

    return (
        <div className={`md:hidden fixed bottom-0 left-0 right-0 z-50 bg-[#0A0A0A]/95 backdrop-blur-2xl border-t border-white/10 rounded-t-3xl shadow-[0_-10px_40px_rgba(0,0,0,0.7)] safe-area-pb pb-2 ${className}`}>
            <nav className="flex items-center justify-around py-2 px-2">
                {items.map((item) => {
                    // Determine if active: use explicit active prop, or check path match
                    const isActive = item.active !== undefined
                        ? item.active
                        : (item.path === '/'
                            ? location.pathname === '/'
                            : location.pathname.startsWith(item.path));

                    return (
                        <button
                            key={item.id || item.label}
                            onClick={item.onClick}
                            className="flex flex-col items-center justify-center p-1 min-w-[64px] group"
                        >
                            {/* Icon Container with Glowing Pill for Active State */}
                            <div className={`relative px-5 py-1.5 rounded-full transition-all duration-300 mb-1 ${isActive
                                ? 'bg-[#7B61FF]/20'
                                : 'bg-transparent group-hover:bg-white/5'
                                }`}>
                                <div className={`transition-transform duration-300 ${isActive ? 'scale-110' : 'group-hover:scale-105'}`}>
                                    <Icon
                                        name={item.icon}
                                        size="sm"
                                        className={isActive ? 'text-[#7B61FF] drop-shadow-[0_0_8px_rgba(123,97,255,0.5)]' : 'text-gray-400 group-hover:text-white'}
                                    />
                                </div>
                                {isActive && (
                                    <div className="absolute inset-0 rounded-full bg-[#7B61FF]/10 blur-sm"></div>
                                )}
                            </div>

                            {/* Label - Subtle and Clean */}
                            <span className={`text-[10px] font-medium tracking-wide transition-colors duration-300 ${isActive ? 'text-white' : 'text-gray-500 group-hover:text-gray-300'
                                }`}>
                                {item.label}
                            </span>
                        </button>
                    );
                })}
            </nav>
        </div>
    );
};
